// extracted by mini-css-extract-plugin
export default {"invalid":"ForgotPassword_invalid__T3dSU"};